import React, { FC } from 'react';
import { Compare } from '@navi-toolbox/ui-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Product } from 'common/components/product-card/types';
import { getIsInComparison } from '../../ducks/selectors';
import { useCompareClick } from './hooks';

const DATA_QA_COMPARE_LIST_ACTION = 'compare-list-action';

type CompareListActionProps = {
  hideText?: boolean;
  product: Product;
  productPosition: number;
  elementBlock: string;
};

export const CompareListAction: FC<CompareListActionProps> = ({
  hideText = undefined,
  product,
  productPosition,
  elementBlock,
}) => {
  const { productId, compareCategory } = product;
  const familyId = compareCategory?.familyId ?? '';
  const isInComparison = useSelector(getIsInComparison(familyId ?? '', productId));
  const { clickHandler } = useCompareClick(product, productPosition, elementBlock);

  const { t } = useTranslation();

  const addedButtonText = t('ui.compare.list-action-added');
  const notAddedButtonText = t('ui.compare.list-action-not-added');

  const buttonTextByActive = isInComparison ? addedButtonText : notAddedButtonText;
  const buttonText = hideText ? undefined : buttonTextByActive;
  const iconSize = hideText ? 'l' : 'm';

  return (
    <Compare
      data-qa={DATA_QA_COMPARE_LIST_ACTION}
      onClick={clickHandler}
      active={isInComparison}
      buttonText={buttonText}
      size={iconSize}
      aria-label={buttonTextByActive}
    />
  );
};
